module.exports = __webpack_public_path__ + "img/FotoMo8.a3517482.png";